<template>
  <InfoCard title="Description">
    <DescriptionField
      :text="description"
      height="100%"
    />
  </InfoCard>
</template>

<script setup>
import InfoCard from '@/components/InfoCard.vue';
import DescriptionField from '@/components/Cards/DescriptionField.vue';

defineProps({
  description: {
    type: String,
    default: '',
  },
});
</script>

<style scoped>
:deep(.description-field) {
  flex: 1 1 auto;
  min-height: 120px;
  border-top: none;
  padding-top: 0;
}
</style>

